import React from 'react';
import PropTypes from 'prop-types';

export const MobileTable = ({
    children,
    nextPageButton,
    isBrownlowV2,
    shouldShowBettingOdds
}) => {
    const modifier = shouldShowBettingOdds
        ? 'player-awards-tracker-leaderboard-mobile-table--show-odds'
        : '';

    return (
        <>
            <div
                className={`player-awards-tracker-leaderboard-mobile-table ${
                    isBrownlowV2 ? 'brownlow-predictor-mobile' : ''
                } ${modifier}`}
            >
                {children}
            </div>
            {nextPageButton}
        </>
    );
};

MobileTable.propTypes = {
    seasonPid: PropTypes.string,
    children: PropTypes.any.isRequired,
    isBrownlowV2: PropTypes.bool,
    nextPageButton: PropTypes.any,
    modifier: PropTypes.string,
    shouldShowBettingOdds: PropTypes.bool
};
